import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import authState from './authReducer';
import globalState from './globalReducer';
import categoriesState from './categoriesReducer';
import consultationsState from './consultationsReducer';
import activityState from './activityReducer';
import additionalDataState from './additionalDataReducer';
import commentsState from './commentsReducer';
import currentUserState from './currentUserReducer';
import reportsState from './reportsReducer';
import suggestionState from './suggestionReducer';
import webinarsState from './webinarsReducer';
import lorealStatisticState from './lorealStatisticReducer';
import nuggetsState from './nuggetsReducer';

export default history => combineReducers({
  router: connectRouter(history),
  authState,
  globalState,
  categoriesState,
  consultationsState,
  activityState,
  additionalDataState,
  commentsState,
  currentUserState,
  reportsState,
  suggestionState,
  webinarsState,
  lorealStatisticState,
  nuggetsState,
});
